import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { class: "switchBar" }
const _hoisted_3 = { class: "image-slot" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: _ctx.addAd
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("添加广告", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "id",
            prop: "id"
          }),
          _createVNode(_component_el_table_column, {
            label: "主标题",
            prop: "firstTitle"
          }),
          _createVNode(_component_el_table_column, {
            label: "副标题",
            prop: "secondTitle"
          }),
          _createVNode(_component_el_table_column, {
            label: "外链",
            prop: "outlink"
          }),
          _createVNode(_component_el_table_column, {
            label: "图片",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_image, {
                src: row.advImg,
                fit: _ctx.contain
              }, null, 8, ["src", "fit"])
            ]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createTextVNode("> ", -1)),
          _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime",
            align: "center"
          }),
          _createVNode(_component_el_table_column, { align: "center" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "success",
                size: "default",
                onClick: ($event: any) => (_ctx.handleEdit(scope.row))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("编辑", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "default",
                onClick: ($event: any) => (_ctx.deleteAd(scope.row.id))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("删除", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        width: "500",
        draggable: "",
        "show-close": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submitReply
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isAdd ? "增加" : "修改"), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "排名" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.adRank,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.adRank) = $event)),
                    autosize: "",
                    type: "number",
                    placeholder: "Please input"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('edit.cover.gameCover')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    limit: 1,
                    "file-list": _ctx.fileList,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.advImg)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: _ctx.form.advImg,
                            class: "avatar",
                            alt: "",
                            fit: 'contain'
                          }, {
                            error: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icon_picture)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode(_toDisplayString("添加图片"), -1)
                            ]))]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.allowUpload)
                ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, { label: "主标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.firstTitle,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.firstTitle) = $event)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "副标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.secondTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.secondTitle) = $event)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "外链" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.outlink,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.outlink) = $event)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onCurrentChange"])
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}